import utils from '../utils/utils'
import anime from '../libs/anime'
import globalVar from '../utils/globalVar'

class ScrollAnime {
  constructor() {
    const tablet = window.matchMedia("(max-width: 1040px)");
    let scrollPos;
    let cache = {};
    let timer;
    let bg = 100;
    let initFunc = () => {
      initCache();
      if(document.querySelector('.loader')) {
        utils.disableScroll();
        anime({
          targets: globalVar.scrollElement,
          duration: 0,
          scrollTop:0,
        });
        loader();
      } else {
        if(window.location.hash) {
          if(document.querySelector(window.location.hash)) {
            anime({
              targets: globalVar.scrollElement,
              duration: 500,
              scrollTop:document.querySelector(window.location.hash).offsetTop+window.innerHeight/1.5,
            });
          }
        }
        else {
          anime({
            targets: globalVar.scrollElement,
            duration: 0,
            scrollTop:0,
          });
        }
        scrollDetect();
        animeNav();
        window.addEventListener('scroll', scrollDetect);
      }
    }

    let initCache = () => {
      if(document.querySelector('.sec_hero')) {
        cache.loader = document.querySelector('.loader');
        cache.heroBg = document.querySelector('.sec_hero .bg')
        cache.heroEl = document.querySelectorAll('.sec_hero .el');
      }
      cache.nav = document.querySelectorAll('header');
      cache.widget = document.querySelectorAll('.widget_links >a, .widget_links >div ');
      if(document.querySelector('.anime-txt_first')) {
        cache.animeTxtFirst = document.querySelectorAll('.anime-txt_first');
      }
      if(document.querySelector('.anime-logo_m')) {
        cache.animeLogoM = document.querySelector('.anime-logo_m');
      }
      if(document.querySelector('.anime-txt')) {
        cache.animeTxt = document.querySelectorAll('.anime-txt');
      }
      if(document.querySelector('.anime-img')) {
        cache.animeImg = document.querySelectorAll('.anime-img');
      }
      if(document.querySelector('.anime-titre')) {
        cache.animeTitre = document.querySelectorAll('.anime-titre');
      }
      if(document.querySelector('.anime-stagger')) {
        cache.animeStagger = document.querySelectorAll('.anime-stagger');
      }
      if(document.querySelector('.anime-stagger_cards')) {
        cache.animeStaggerCards = document.querySelectorAll('.anime-stagger_cards');
      }
      if(document.querySelector('.banner')) {
        cache.animeBanners = document.querySelectorAll('.banner');
      }
      if(document.querySelector('.bandeau_wrap')) {
        cache.animeBandeau = document.querySelectorAll('.bandeau_wrap');
      }
    };

    let loader = function() {
      initBg();
      addEventListener("resize", initBg);
      anime({
        targets: cache.loader.querySelector('.main'),
        translateY: ['0%', '-100%'],
        duration: 1000,
        delay: 1500,
        easing: 'easeOutCirc',
        complete: function() {
          scrollPos = 0;
          scrollDetect();
          animeNav();
          window.addEventListener('scroll', scrollDetect);

          for (var i = 0; i < cache.heroEl.length; i++) {
            anime({
              targets: cache.heroEl[i],
              scale: [0.85, 1],
              rotate: [8, 0],
              opacity:[0, 1],
              duration: 600,
              delay: 200 + (100*i),
              easing: 'easeOutCirc',
            });
          }
          anime({
            targets: document.querySelectorAll('.sec_hero .btn'),
            scale: [0.85, 1],
            translateY: [50, 0],
            opacity:[0, 1],
            duration: 500,
            delay: 800,
            easing: 'spring(1, 100, 10, 10)',
            complete: function() {
              utils.enableScroll();
            }
          });
        }
      });
      anime({
        targets: cache.loader.querySelector('.rect1'),
        translateY: ['0%', '-100%'],
        duration: 800,
        delay: 1700,
        easing: 'easeOutCirc',
      });
      anime({
        targets: cache.loader.querySelector('.rect2'),
        translateY: ['0%', '-100%'],
        duration: 600,
        delay: 1850,
        easing: 'easeOutCirc',
        complete: function() {
          cache.loader.remove();
        }
      });
    }


    let initBg = () => {
      let wH = window.innerHeight;
      let wW = window.innerWidth;
      let rScreen = wW/wH;

      let imageSrc = cache.heroBg.style.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2').split(',')[0];
      let image = new Image();
      image.src = imageSrc;
      let imgH = image.height;
      let imgW = image.width;
      let rImg = imgW/imgH;

      if(rScreen < rImg) {
        bg = 100+((rImg - rScreen)*100);
      }else {
        bg = 100;
      }
      cache.heroBg.style.backgroundSize = (bg + '% auto');
    }


    let animeNav = function() {
      anime({
        targets: cache.nav,
        translateY: [-50, 0],
        translateX: ['-50%', '-50%'],
        scale: [0.97, 1],
        opacity: [0,1],
        duration: 600,
        easing: 'easeOutCirc',
      });
      for (var i = 0; i < cache.widget.length; i++) {
        anime({
          targets: cache.widget[i],
          scale: [1.4, 1],
          rotate: [-5, 1],
          opacity: [0,1],
          duration: 700,
          delay: 300 + (100*i),
          easing: 'easeOutCirc',
        });
      }
      if(document.querySelector('.anime-txt_first')) {
        for (var i = 0; i < cache.animeTxtFirst.length; i++) {
          if(!cache.animeTxtFirst[i].classList.contains('animated')) {
            anime({
              targets: cache.animeTxtFirst[i],
              translateY: [50, 0],
              scale: [0.97, 1],
              opacity: [0,1],
              delay: (400 + i*100),
              duration: 800,
              easing: 'easeOutCirc',
            });
          }
        }
      }
      if(document.querySelector('.anime-logo_m') && tablet.matches) {
        anime({
          targets: cache.animeLogoM,
          translateY: ["-50%", "-50%"],
          translateX: ["-50%", "-50%"],
          scale: [0.9, 1],
          opacity: [0,1],
          delay: 300,
          duration: 400,
          easing: 'easeOutCirc',
        });
      }
    }

    let scrollDetect = function() {
      let up = false;
      if(scrollPos > window.pageYOffset) {
        up = true;
      }
      scrollPos = window.pageYOffset;


// TEXTE
      if(document.querySelector('.anime-txt')) {
        for (let i = 0; i < cache.animeTxt.length; i++) {
          if(((scrollPos+(window.innerHeight/1.5)) > utils.getOffsetTop(cache.animeTxt[i])) && (!cache.animeTxt[i].classList.contains('animated'))){
            cache.animeTxt[i].classList.add('animated');
            anime({
              targets: cache.animeTxt[i],
              translateY: [50, 0],
              scale: [0.97, 1],
              opacity: [0,1],
              duration: 800,
              easing: 'easeOutCirc',
            });
          }
        }
      }


// IMAGE
      if(document.querySelector('.anime-img')) {
        for (let i = 0; i < cache.animeImg.length; i++) {
          if(((scrollPos+(window.innerHeight/1.5)) > utils.getOffsetTop(cache.animeImg[i])) && (!cache.animeImg[i].classList.contains('animated'))){
            cache.animeImg[i].classList.add('animated');
            anime({
              targets: cache.animeImg[i],
              translateY: [50, 0],
              opacity: [0,1],
              scale: [0.95, 1],
              rotate: [-10, 0],
              duration: 800,
              easing: 'easeOutCirc',
            });
          }
        }
      }


// TITRE
      if(document.querySelector('.anime-titre')) {
        for (let i = 0; i < cache.animeTitre.length; i++) {
          if(((scrollPos+(window.innerHeight/1.4)) > utils.getOffsetTop(cache.animeTitre[i])) && (!cache.animeTitre[i].classList.contains('animated'))){
            cache.animeTitre[i].classList.add('animated');
            anime({
              targets: cache.animeTitre[i].querySelector('.inner'),
              translateY: ['105%', '0%'],
              rotate: [10, 0],
              skewX: [5,0],
              skewY: [5,0],
              duration: 800,
              easing: 'easeOutCirc',
            });
          }
        }
      }


// MULTIPLE ELEMENTS
      if(document.querySelector('.anime-stagger')) {
        for (let i = 0; i < cache.animeStagger.length; i++) {
          if(((scrollPos+(window.innerHeight/1.5)) > utils.getOffsetTop(cache.animeStagger[i])) && (!cache.animeStagger[i].classList.contains('animated'))){
            cache.animeStagger[i].classList.add('animated');
            let el = cache.animeStagger[i].querySelectorAll('div, a');
            for (let ii = 0; ii < el.length; ii++) {
              anime({
                targets: el[ii],
                translateY: [20, 0],
                opacity: [0,1],
                scale: [0.85, 1],
                duration: 500,
                delay: 50*ii,
                easing: 'easeOutCirc',
              });
            }
          }
        }
      }


// CARDS
      if(document.querySelector('.anime-stagger_cards') && !tablet.matches) {
        for (let i = 0; i < cache.animeStaggerCards.length; i++) {
          if(((scrollPos+(window.innerHeight/1.5)) > utils.getOffsetTop(cache.animeStaggerCards[i])) && (!cache.animeStaggerCards[i].classList.contains('animated'))){
            cache.animeStaggerCards[i].classList.add('animated');
            let el = cache.animeStaggerCards[i].querySelectorAll(':scope > div, :scope > a');
            for (let ii = 0; ii < el.length; ii++) {
              anime({
                targets: el[ii],
                translateY: [10, 0],
                opacity: [0,1],
                scale: [0.95, 1],
                duration: 400,
                delay: 50*ii,
                easing: 'easeOutCirc',
              });
            }
          }
        }
      }


// BANNER
      if(document.querySelector('.banner')) {
        for (let i = 0; i < cache.animeBanners.length; i++) {
          if(((scrollPos+(window.innerHeight/1.5)) > utils.getOffsetTop(cache.animeBanners[i])) && (!cache.animeBanners[i].classList.contains('animated'))){
            cache.animeBanners[i].classList.add('animated');

            anime({
              targets: cache.animeBanners[i].querySelector('.bg_banner'),
              translateX: [-100, 0],
              opacity: [0,1],
              scale: [0.95, 1],
              duration: 400,
              easing: 'easeOutCirc',
            });
            anime({
              targets: cache.animeBanners[i].querySelector('.img'),
              opacity: [0,1],
              scale: [0.92, 1],
              duration: 500,
              delay: 100,
              easing: 'easeOutCirc',
            });
            anime({
              targets: cache.animeBanners[i].querySelector('.left'),
              translateY: [50, 0],
              opacity: [0,1],
              scale: [0.92, 1],
              duration: 600,
              delay: 200,
              easing: 'easeOutCirc',
            });
            anime({
              targets: cache.animeBanners[i].querySelector('.logo_m'),
              opacity: [0,1],
              scale: [0.92, 1],
              rotate: [-10, 0],
              duration: 400,
              delay: 300,
              easing: 'easeOutCirc',
            });
          }
        }
      }


// HOME HERO ELEMENTS
      if(document.querySelector('.sec_hero')) {
        for (let i = 0; i < cache.heroEl.length; i++) {
          if(((scrollPos+(window.innerHeight/1.5)) > utils.getOffsetTop(cache.heroEl[i])) && (scrollPos < utils.getOffsetTop(cache.heroEl[i])+document.querySelector('.sec_hero').offsetHeight)){
            let percent = scrollPos/(utils.getOffsetTop(cache.heroEl[i])+document.querySelector('.sec_hero').offsetHeight);
            if(i == 0) {
              let anime0 = anime({
                targets: cache.heroEl[i],
                translateY: ['0%', '25%'],
                rotate: [0,-20],
                duration: 1000,
                easing: 'linear',
                autoplay: false
              });
              anime0.seek((percent*1.5) * anime0.duration);
            }
            if(i == 1) {
              let anime1 = anime({
                targets: cache.heroEl[i],
                translateY: ['0%', '25%'],
                rotate: [0,80],
                translateX: '0%',
                scale: [1, 0.85],
                duration: 1000,
                easing: 'linear',
                autoplay: false
              });
              anime1.seek((percent*1.7) * anime1.duration);
            }
            if(i == 2) {
              let anime2 = anime({
                targets: cache.heroEl[i],
                translateY: ['0%', '25%'],
                rotate: [0,20],
                duration: 1000,
                easing: 'linear',
                autoplay: false
              });
              anime2.seek((percent*1.7) * anime2.duration);
            }
            if(i == 3) {
              let anime3 = anime({
                targets: cache.heroEl[i],
                translateY: ['0%', '55%'],
                rotate: [0,-10],
                duration: 1000,
                easing: 'linear',
                autoplay: false
              });
              anime3.seek((percent*1.7) * anime3.duration);
            }

// ANIME BG HERO
            if(!tablet.matches) {
              let animeBg = anime({
                targets: document.querySelector('.sec_hero .bg'),
                backgroundSize: [(bg+'% auto'), ((bg+20)+'% auto')],
                backgroundPositionY: ['50%', '360%'],
                duration: 1000,
                easing: 'linear',
                autoplay: false
              });
              animeBg.seek((percent*1.2) * animeBg.duration);
            }

            let animeBtn = anime({
              targets: document.querySelector('.sec_hero .btn'),
              translateY: ['0%', '400%'],
              duration: 1000,
              easing: 'linear',
              autoplay: false
            });
            animeBtn.seek((percent*1.7) * animeBtn.duration);
          }
        }
      }


// BANDEAU DE TEXTE

      if(document.querySelector('.bandeau_wrap')) {
        for (var i = 0; i < cache.animeBandeau.length; i++) {
          if(((scrollPos + window.innerHeight) > utils.getOffsetTop(cache.animeBandeau[i])) && ((scrollPos - window.innerHeight) < utils.getOffsetTop(cache.animeBandeau[i])+cache.animeBandeau[i].offsetHeight)){
            let percent = scrollPos/(utils.getOffsetTop(cache.animeBandeau[i])+cache.animeBandeau[i].offsetHeight);
            let band = cache.animeBandeau[i].querySelectorAll('.bandeau');

    // DETECT SCROLL STOP
            if(timer !== null) {
              clearTimeout(timer);
            }
            timer = setTimeout(function() {
              if(band[0].classList.contains('skew-up') || band[0].classList.contains('skew-down')) {
                band[0].classList.remove('skew-up');
                band[0].classList.remove('skew-down');
                let txt = band[0].querySelectorAll(".txt");
                for (var i = 0; i < txt.length; i++) {
                  anime({
                    targets: txt[i],
                    skewX: 0,
                    duration: 50,
                    easing: 'easeInCirc',
                  });
                }
              }
              if(band[1].classList.contains('skew-up') || band[1].classList.contains('skew-down')) {
                band[1].classList.remove('skew-up');
                band[1].classList.remove('skew-down');
                let txt = band[1].querySelectorAll(".txt");
                for (var i = 0; i < txt.length; i++) {
                  anime({
                    targets: txt[i],
                    skewX: 0,
                    duration: 50,
                    easing: 'easeInCirc',
                  });
                }
              }
            }, 50);

        // ANIME SKEW
            if(up) {
              if(!band[0].classList.contains('skew-up')) {
                band[0].classList.add('skew-up');
                band[0].classList.remove('skew-down');
                let txt = band[0].querySelectorAll(".txt");
                for (var i = 0; i < txt.length; i++) {
                  anime({
                    targets: txt[i],
                    skewX: 10,
                    duration: 100,
                    easing: 'easeInCirc',
                  });
                }
              }
              if(!band[1].classList.contains('skew-up')) {
                band[1].classList.add('skew-up')
                band[1].classList.remove('skew-down');
                let txt = band[1].querySelectorAll(".txt");
                for (var i = 0; i < txt.length; i++) {
                  anime({
                    targets: txt[i],
                    skewX: -10,
                    duration: 100,
                    easing: 'easeInCirc',
                  });
                }
              }
            }else {
              if(!band[0].classList.contains('skew-down')) {
                band[0].classList.add('skew-down');
                band[0].classList.remove('skew-up');
                let txt = band[0].querySelectorAll(".txt");
                for (var i = 0; i < txt.length; i++) {
                  anime({
                    targets: txt[i],
                    skewX: -10,
                    duration: 100,
                    easing: 'easeInCirc',
                  });
                }
              }
              if(!band[1].classList.contains('skew-down')) {
                band[1].classList.add('skew-down');
                band[1].classList.remove('skew-up');
                let txt = band[1].querySelectorAll(".txt");
                for (var i = 0; i < txt.length; i++) {
                  anime({
                    targets: txt[i],
                    skewX: 10,
                    duration: 100,
                    easing: 'easeInCirc',
                  });
                }
              }
            }


              let band0 = anime({
                targets: band[0],
                translateX: ['0%', '-75%'],
                duration: 1000,
                easing: 'linear',
                autoplay: false
              });
              let band1 = anime({
                targets: band[1],
                translateX: ['-75%', '0%'],
                duration: 1000,
                easing: 'linear',
                autoplay: false
              });
              band0.seek((percent*0.66) * band0.duration);
              band1.seek((percent*0.66) * band1.duration);


          }
        }
      }


    }

    initFunc();
  };
}
export { ScrollAnime }
